import { Component, inject, Input } from '@angular/core';
import { NavigationService } from '../../../core/navigation/navigation.service';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { VexConfigService } from '@vex/config/vex-config.service';
import { map } from 'rxjs/operators';
import { NavigationItem } from '../../../core/navigation/navigation-item.interface';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SearchModalComponent } from './search-modal/search-modal.component';
import { SidenavItemComponent } from './sidenav-item/sidenav-item.component';
import { VexScrollbarComponent } from '@vex/components/vex-scrollbar/vex-scrollbar.component';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { CurrentUserModel } from '@shared/common/models';
import { BuildInfoComponent } from '../../../pages/auth/components/build-info.component';

@Component({
    selector: 'vex-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MatButtonModule,
        MatIconModule,
        MatRippleModule,
        VexScrollbarComponent,
        NgFor,
        SidenavItemComponent,
        AsyncPipe,
        BuildInfoComponent,
    ],
})
export class SidenavComponent {
    @Input() collapsed = false;
    public currentUser = inject(CurrentUserModel);
    private layoutService = inject(VexLayoutService);
    private configService = inject(VexConfigService);
    private navigationService = inject(NavigationService);
    private dialog = inject(MatDialog);
    collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
    title$ = this.configService.config$.pipe(map((config) => config.sidenav.title));
    imageUrl$ = this.configService.config$.pipe(map((config) => config.sidenav.imageUrl));
    showCollapsePin$ = this.configService.config$.pipe(
        map((config) => config.sidenav.showCollapsePin),
    );
    userVisible$ = this.configService.config$.pipe(map((config) => config.sidenav.user.visible));
    searchVisible$ = this.configService.config$.pipe(
        map((config) => config.sidenav.search.visible),
    );

    items$: Observable<NavigationItem[]> = this.navigationService.items$;

    collapseOpenSidenav() {
        this.layoutService.collapseOpenSidenav();
    }

    collapseCloseSidenav() {
        this.layoutService.collapseCloseSidenav();
    }

    toggleCollapse() {
        this.collapsed ? this.layoutService.expandSidenav() : this.layoutService.collapseSidenav();
    }

    trackByRoute(index: number, item: NavigationItem): string {
        if (item.type === 'link') {
            return item.route;
        }

        return item.label;
    }

    openSearch(): void {
        this.dialog.open(SearchModalComponent, {
            panelClass: 'vex-dialog-glossy',
            width: '100%',
            maxWidth: '600px',
        });
    }
}
